import React from "react";
import momentTimezone from "moment-timezone";
import ReactTooltip from "react-tooltip";

const GeneratedTooltip = ({ children, index, id }) => {
  return (
    <>
      <span data-tip data-for={`${id}${index}`}>
        {children}
      </span>
      {children && (
        <ReactTooltip type="dark" effect="solid" id={`${id}${index}`}>
          {children}
        </ReactTooltip>
      )}
    </>
  );
};

const GenericCell = ({ value, row: { index }, column: { id } }) => (
  <GeneratedTooltip index={index} id={id}>
    {value}
  </GeneratedTooltip>
);

const DateCell = ({ value, row: { index }, column: { id } }) => {
  const _date = value
    ? momentTimezone(Number(value))
        .tz("America/New_York")
        .format("MMMM D, YYYY")
    : "";
  return (
    <GeneratedTooltip index={index} id={id}>
      {_date}
    </GeneratedTooltip>
  );
};

const getColumns = (isEmergency) => {
  if (typeof isEmergency === "string") {
    isEmergency = isEmergency.toUpperCase() === "YES" ? true : false;
  }
  let columnAccessors = {
    caseNumber: "caseNumber",
    empBusinessName: "empBusinessName",
    empFein: "empFein",
    jobTitle: "jobTitle",
    pwdLinkingSocCode: "pwdLinkingSocCode",
    suggestedSocCode: "suggestedSocCode",
    dateSubmitted: "dateSubmitted",
    determinationDate: "caseMetadata",
  };

  let columns = [
    {
      Header: "Case Number",
      id: "caseNumber",
      minWidth: 170,
      maxWidth: 180,
      accessor: (d) => d[columnAccessors.caseNumber],
      Cell: GenericCell,
    },
    {
      Header: "Employer Name",
      id: "empBusinessName",
      minWidth: 175,
      accessor: (d) => d[columnAccessors.empBusinessName],
      Cell: GenericCell,
    },
    {
      Header: "FEIN",
      id: "empFein",
      minWidth: 100,
      maxWidth: 110,
      accessor: (d) => d[columnAccessors.empFein],
      Cell: GenericCell,
    },
    {
      Header: "Job Title",
      id: "jobTitle",
      minWidth: 175,
      accessor: (d) => d[columnAccessors.jobTitle],
      Cell: GenericCell,
    },
    {
      Header: `Suggested SOC`,
      id: "suggestedSocCode",
      minWidth: 130,
      show: isEmergency,
      accessor: (d) => {
        // requirement update if determined soc exists make this blank
        return d[columnAccessors.pwdLinkingSocCode]
          ? ""
          : d[columnAccessors.suggestedSocCode];
      },
      Cell: GenericCell,
    },
    {
      Header: "Determined SOC",
      id: "pwdLinkingSocCode",
      minWidth: 140,
      accessor: (d) => d[columnAccessors.pwdLinkingSocCode],
      Cell: GenericCell,
    },
    {
      Header: "Determination Date",
      id: "determinationDate",
      minWidth: 160,
      accessor: (d) => d[columnAccessors.determinationDate].determinationDate,
      Cell: DateCell,
    },
    {
      Header: "Submitted Date",
      id: "dateSubmitted",
      minWidth: 160,
      show: isEmergency,
      accessor: (d) => d[columnAccessors.dateSubmitted],
      Cell: DateCell,
    },
  ];
  return columns;
};

export default getColumns;
